const __env: String = 'local' || window.location.hostname;

const __configuration = {
	'baseUrl': '',
	'port': '',
	'encryption': false,
	'encryptionKey': 'R4jN4ND!84!!4',
	'logs': true,
	'allowAll': false
};

function getConfig() {
	switch (__env) {
		case 'local':
	 	__configuration.baseUrl = 'http://localhost:4200/'; 
			__configuration.port = '';
			__configuration.allowAll = true;
			break;
		case 'dev':
			__configuration.baseUrl = '';
			__configuration.port = '';
			__configuration.encryption = true;
			__configuration.logs = false;
			__configuration.allowAll = true;
			break;
		case 'uat':
			__configuration.baseUrl = '';
			__configuration.port = '';
			__configuration.encryption = true;
			__configuration.logs = false;
			break;
		case 'sit':
			__configuration.baseUrl = '';
			__configuration.port = '';
			__configuration.encryption = true;
			__configuration.logs = false;
			break;
		default:
			__configuration.baseUrl = '';
			__configuration.port = '';
	}
	return __configuration;
}

export const config = getConfig();
